import { createSlice } from "@reduxjs/toolkit";
import {
  deleteResultCategory,
  getAllResultCategory,
  getResultCategory,
  undoDeleteResultCategory,
} from "./ResultCategory.api";

const resultCategorySlice = createSlice({
  name: "resultCategory",
  initialState: {
    resultCategory: [],
    resultAllCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getResultCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getResultCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.resultCategory = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getResultCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getAllResultCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllResultCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.resultAllCategory = action.payload;
    });
    builder.addCase(getAllResultCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteResultCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteResultCategory.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.resultCategory.data) {
        state.resultCategory.data = state.resultCategory.data.filter(
          (resultCategory) => {
            return resultCategory._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.resultCategory.data is not an array:",
          state.resultCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteResultCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteResultCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteResultCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.resultCategory.data) {
        state.resultCategory.data = state.resultCategory.data.filter(
          (resultCategory) => {
            return resultCategory._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.resultCategory.data is not an array:",
          state.resultCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteResultCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = resultCategorySlice.actions;
export default resultCategorySlice.reducer;
